<template>
<!-- 新增检验类别 -->
    <div class="add-dialog">
        <el-dialog
        title="新增检验类别"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="60%"
        v-loading="loading"
        :close-on-click-modal='false'
        >
            <div class="header">
                <p></p>
                <h1>基础信息</h1>
            </div>
            <div class="content">
                <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                    <el-form ref="form" :rules="rules" :model="form" label-width="110px" size='small'>
                        <el-form-item label="分类名称：" prop="categoryName">
                            <el-input style="width:40%" v-model="form.categoryName" placeholder="请输入分类名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="上级分类：">
                            <el-select v-model="form.parentId" placeholder="请选择上级分类" style="width:40%" clearable>
                                <el-option v-for="(item,index) in drugArr" :key="index" :label="item.categoryName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否启用：" prop="status">
                            <el-radio-group v-model="form.status">
                                <el-radio :label="false">是</el-radio>
                                <el-radio :label="true">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input type="textarea" v-model="form.remark" style="width:40%;" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button style="width:110px;height:32px;" @click="form={}">重置</el-button>
                            <el-button type="primary" @click="onSubmit" style="width:110px;height:32px;background:#1A7BFC;border-color:#1A7BFC">保存</el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { apiAddStandardCategroy,apiStandardInfoUpdate } from '../../../case-3/api/index'
    export default {
        data() {
            return {
                dialogVisible: false,
                form:{status:false},
                loading:false,
                drugArr:[],
                rules:{
                    categoryName: [
                      { required: true, message: '请输入分类名称', trigger: 'blur' },
                    ],
                    status:[
                      { required: true, message: '请选择是否启用', trigger: 'blur' },
                    ],
                },
            }
        },
        methods: {
            /**
             * @description:  打开弹窗
             * @param {*}
             * @return {*}
            */
            openDialog() {
                this.form = {status:false}
                this.dialogVisible = true
                apiStandardInfoUpdate({
                    status:false,
                    type:2,
                    parentId:0,
                }).then(res=>{
                    this.drugArr = res.data
                })
            },
            /**
             * @description:  保存表单
             * @param {*}
             * @return {*}
            */
            onSubmit(){
                this.$refs.form.validate((valid) => {
                    if(!this.form.parentId){
                        this.form.parentId = 0
                    }
                    this.loading = true
                    this.form.type = 2
                    if (valid) {
                        apiAddStandardCategroy({...this.form}).then(res=>{
                            if(res.code == 0){
                                this.$message({
                                    message: '添加成功',
                                    type: 'success'
                                });
                                this.loading = false
                                this.$parent.getTestList()
                                this.dialogVisible = false
                            }else{
                                this.loading = false
                                this.$message.error(res.message);
                            }
                        }).catch(e => {
                            this.loading = false
                        })
                    } else {
                        this.loading = false
                        return false;
                    }
                });
            },
        },
    }
</script>

<style lang="less" scoped>
.header{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    p{
        width: 4px;
        height: 15px;
        background: #1A7BFC;
        margin-right: 12px;
    }
    h1{
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
    }
}
.add-dialog{
    .title{
        font-size: 14px;
        color: #000;
        border-left: 4px solid #1A7BFC;
        padding-left: 10px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .content{
        height: calc(80vh - 140px);
        width: 100%;
    }
}
/deep/.el-dialog{
    height: 80vh;
}
/deep/.el-dialog__title{
    font-weight: 26px;
    color: #333;
    font-weight: bold;
}

</style>
